import {authFetch} from '../utils/authFetch';
export async function loadDevizVat(order,repairPartId){
 const response=await authFetch('/firma');const firm=response?.items?.[0];
 if(firm?.platitor_tva==null || ![0,1].includes(Number(firm.platitor_tva)))throw new Error('Statutul TVA al firmei nu este configurat.');
 const ids=new Set((order.reteta||[]).map(row=>Number(row.bxpart_id)));
 if(order.manopere?.length)ids.add(Number(repairPartId));
 const rates=new Map(await Promise.all([...ids].map(async id=>{
  if(!Number(firm.platitor_tva))return [id,0];
  const part=await authFetch(`/bxpart/${id}`);const rate=part?.grupa_produse?.bxvat_procent??part?.bxvat_procent;
  if(rate==null||rate===''||!Number.isFinite(Number(rate))||Number(rate)<0)throw new Error(`Configurează cota TVA în grupa articolului ${part?.cod||id}.`);
  return [id,Number(rate)];
 })));
 return id=>{if(!rates.has(Number(id)))throw new Error('Lipsește cota TVA a articolului.');return rates.get(Number(id));};
}
